import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Button, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';

export default function PromoCodeListScreen() {
  const [code, setCode] = useState('');
  const [discountType, setDiscountType] = useState('percentage');
  const [discountValue, setDiscountValue] = useState('');
  const [triggerProduct, setTriggerProduct] = useState('');
  const [freeProduct, setFreeProduct] = useState('');
  const [expiresAt, setExpiresAt] = useState('');
  const [usageLimit, setUsageLimit] = useState('');
  const [products, setProducts] = useState([]);

  useEffect(() => {
    axios.get('/api/products').then(({ data }) => setProducts(data));
  }, []);

  const needsDiscountValue = ['percentage', 'fixed', 'buy2_least_percentage'].includes(discountType);
  const isBuyXGetY = discountType === 'buy_x_get_y_free';

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        code: code.toUpperCase(),
        discountType,
        expiresAt: expiresAt ? new Date(expiresAt) : undefined,
        usageLimit: usageLimit ? Number(usageLimit) : undefined,
      };

      if (needsDiscountValue) {
        payload.discountValue = Number(discountValue);
      }
      if (isBuyXGetY) {
        payload.triggerProduct = triggerProduct;
        payload.freeProduct = freeProduct;
      }

      await axios.post('/api/promos', payload, {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('userInfo')).token}`,
        },
      });
      toast.success('Promo code created!');
      setCode('');
      setDiscountValue('');
      setTriggerProduct('');
      setFreeProduct('');
      setExpiresAt('');
      setUsageLimit('');
    } catch (err) {
      toast.error(err.response?.data?.message || err.message);
    }
  };

  return (
    <Card className="mx-auto my-5" style={{ maxWidth: '450px' }}>
      <Card.Body>
        <h2 className="mb-3">Create Promo Code</h2>
        <Form onSubmit={submitHandler}>
          <Form.Group className="mb-3" controlId="code">
            <Form.Label>Code</Form.Label>
            <Form.Control
              type="text"
              required
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="discountType">
            <Form.Label>Discount Type</Form.Label>
            <Form.Select
              value={discountType}
              onChange={(e) => setDiscountType(e.target.value)}
            >
              <option value="percentage">Percentage off total</option>
              <option value="fixed">Fixed amount off total</option>
              <option value="buy2_least_percentage">Buy 2+ items – % off cheapest</option>
              <option value="buy_x_get_y_free">Buy product X, get product Y free</option>
            </Form.Select>
          </Form.Group>

          {needsDiscountValue && (
            <Form.Group className="mb-3" controlId="discountValue">
              <Form.Label>
                {discountType === 'fixed' ? 'Discount Amount (EGP)' : 'Discount Percentage (%)'}
              </Form.Label>
              <Form.Control
                type="number"
                min="0"
                required
                value={discountValue}
                onChange={(e) => setDiscountValue(e.target.value)}
              />
              {discountType === 'buy2_least_percentage' && (
                <Form.Text className="text-muted">
                  Applied to the cheapest item when 2+ items are in the cart.
                </Form.Text>
              )}
            </Form.Group>
          )}

          {isBuyXGetY && (
            <>
              <Form.Group className="mb-3" controlId="triggerProduct">
                <Form.Label>Trigger Product</Form.Label>
                <Form.Select
                  required
                  value={triggerProduct}
                  onChange={(e) => setTriggerProduct(e.target.value)}
                >
                  <option value="">— Select product —</option>
                  {products.map((p) => (
                    <option key={p._id} value={p._id}>{p.name}</option>
                  ))}
                </Form.Select>
                <Form.Text className="text-muted">
                  Customer must have this product in their cart.
                </Form.Text>
              </Form.Group>
              <Form.Group className="mb-3" controlId="freeProduct">
                <Form.Label>Free Product</Form.Label>
                <Form.Select
                  required
                  value={freeProduct}
                  onChange={(e) => setFreeProduct(e.target.value)}
                >
                  <option value="">— Select product —</option>
                  {products.map((p) => (
                    <option key={p._id} value={p._id}>{p.name}</option>
                  ))}
                </Form.Select>
                <Form.Text className="text-muted">
                  This product will be free when the trigger product is in the cart.
                </Form.Text>
              </Form.Group>
            </>
          )}

          <Form.Group className="mb-3" controlId="expiresAt">
            <Form.Label>Expires At</Form.Label>
            <Form.Control
              type="date"
              value={expiresAt}
              onChange={(e) => setExpiresAt(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="usageLimit">
            <Form.Label>Usage Limit</Form.Label>
            <Form.Control
              type="number"
              value={usageLimit}
              onChange={(e) => setUsageLimit(e.target.value)}
            />
          </Form.Group>

          <div className="d-grid">
            <Button type="submit" variant="primary">
              Create Promo Code
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}